import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly title = inject(Title);
  private readonly brandName = 'JestyLine';

  set(pageTitle?: string | null): void {
    const normalized = (pageTitle ?? '').trim();
    this.title.setTitle(normalized ? `${normalized} | ${this.brandName}` : this.brandName);
  }
}
